import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import SettingProfileFirstPart from './SettingProfileContainer/settingProfileFirstPart'
import SettingProfileSecondPart from './SettingProfileContainer/settingProfileSecondPart'
import { useParams } from 'react-router-dom'

const SettingProfile = () => {

const code  = useParams()?.code
const codesValides = ['0', '1'] 
if (code && !codesValides.includes(code)) {
  return <Navigate to="/404" replace />
}
return (
    <div className='w-full px-8 sm:px-0 space-y-10'>
     
        <SettingProfileFirstPart />
        <SettingProfileSecondPart code={code}/>
      
    </div>
  )
}

export default SettingProfile
